import { operators as o } from '@pendo/aggregations';
import { getPipelineProps, compile } from '@/segments/segment';

export default class SegmentCardHelper {
    static buildAudiencePipeline (filters, advancedOptions) {
        return Promise.resolve(compile(filters, advancedOptions));
    }

    static async buildCustomAudiencePipeline (segment, { showGuidesToAnon, isReplayCaptureSegment = false } = {}) {
        const segmentPipeline = await getPipelineProps(segment);

        let visitorEntrySource = [
            o.sources.visitors({ identified: !showGuidesToAnon && !isReplayCaptureSegment, blacklist: 'ignore' })];

        // Not an amazing long term solution, but guides currently do not play nicely with compound segments
        // and `pipelines` objects (vs just a single pipline array)
        // We really need to update guides to allow `audience` to contain non-array objects, ala compound segments.
        // Once we've done that we _should in theory_ be able to delete this entire function, and just use the
        // output from the sgement editor
        if(segment.pipelines && !isReplayCaptureSegment) {
            if(segment.pipelines.inlineIdentifiedVisitorsOnly) {
                visitorEntrySource = [
                    o.sources.visitors({ blacklist: 'ignore' }),
                    o.identified('visitorId'),
                ];
            } else if(segment.pipelines.inlineAnonymousVisitorsOnly) {
                visitorEntrySource = [
                    o.sources.visitors({ blacklist: 'ignore' }),
                    o.identified('!visitorId'),
                ];
            }
        }

        return o.pipeline(
            ...visitorEntrySource,
            o.evaluate('accountId', 'metadata.auto.accountids'),
            o.unwind('accountId', { keepEmpty: true }),
            o.segment(segmentPipeline),
            o.select({ visitorId: 'visitorId' }),
            o.group(['visitorId']),
        );
    }
}
